import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import RegisterIncomeForm from "./form";
import ieSvg from "../../components/icons/ieSvg";
import {connect} from "react-redux";
import ServerWaiting from "../server/loading";
import ServerError from "../server/error";

class RegisterClient extends React.Component {

  componentDidMount() {
    document.title = "Добавить клиента | Самозанятые";
    ieSvg();
  }

  render() {
    const partner = this.props.partnerProperties.items;
    if(partner) {
      if(partner.data?.autoRegistrationIncomes) {
        return (
          <div className={styles.content}>
            <div className="l-grid_pt-8 mobile_l-grid">
              <div className="l-grid__item_1">{''}</div>
              <div className="l-grid__item_6 mobile_l-grid__item_10">
                <Title icon="icon_menu-clients" title="Добавить клиента"/>
                <div className={styles.article}>
                  С момента добавления клиента, поступления от него будут автоматически фиксироваться как ваш доход.
                </div>
                <RegisterIncomeForm />
              </div>
            </div>
          </div>
        )
      }
      else return <ServerError pageTitle="Добавить клиента" pageIcon="icon_menu-clients" errorMessage='Данный функционал недоступен.' />
    }
    else return <ServerWaiting  pageTitle="Добавить клиента" waiting="Загружаем форму добавления клиента..."  pageIcon="icon_menu-clients" />
  }
}

const mapStateToProps = state => ({partnerProperties: state.partnerProperties});

export default connect(mapStateToProps)(RegisterClient);